import React from "react";
// import AnsQandAUserAll from "../ansuser/AnsQandAUserAll"
import AnsQandAUserAll from "../ansuser/NewAnsQandAUserAll";
import Footer from "../footer/Footer";

import HeadBar from "./headBar/HeadBar";

export default function AnsQandA() {
  return (
    <>
      <div className="global-page">
        <AnsQandAUserAll />
      </div>
    </>
  );
}
